export function trim (string: string, maxLength?: number): string {
  if (!string || typeof string !== 'string') {
    return ''
  }

  if (!maxLength || string.length <= maxLength) {
    return string
  }

  return string.substr(0, maxLength) + '...'
}
